import switchMarket from './SwitchMarket';

export default switchMarket;
